import styled from "@emotion/styled";
import { ContextButton } from "@stepfinance/react";
import type { FC } from "react";

import SteppyOkHand from "../../assets/steppy-ok-hand.svg";
import { useLanguageContext } from "../../contexts/language/language";
import type { ModalProps } from "../Modal/Modal";
import { Modal } from "../Modal/Modal";
import { TextDescription, TextTitle } from "../shared";

interface UnboughtTierProps extends Omit<ModalProps, "title" | "children" | "TitleIcon"> {
  onSuccess: () => void;
}

export const UnboughtTier: FC<UnboughtTierProps> = ({ onSuccess, onClose, ...props }) => {
  const handleClose = () => {
    onClose();
  };

  const {
    currentLanguageData: {
      components: { unboughtTier },
    },
  } = useLanguageContext();

  return (
    <Modal onClose={handleClose} {...props} title={""}>
      <ContentContainer>
        <TextTitle className="title" size="xl">
          {unboughtTier.getYourTransactions}
        </TextTitle>
        <TextDescription className="description">{unboughtTier.tierBasedSystemDescription}</TextDescription>
        <div className="step-icon-container">
          <img src={SteppyOkHand} width={216} height={170} alt="Steppy" />
        </div>
      </ContentContainer>
      <StyledContextButton onClick={onSuccess} className="tiers-button" block>
        {unboughtTier.seeAvailableTiersButton}
      </StyledContextButton>
    </Modal>
  );
};

const ContentContainer = styled.div`
  width: 385px;
  margin: auto;
  .title {
    text-align: center;
  }
  .description {
    margin: 16px 0;
    text-align: center;
  }
  .step-icon-container {
    display: flex;
    justify-content: center;
  }
`;

const StyledContextButton = styled(ContextButton)`
  margin-top: 24px;
  height: 48px;
  max-height: 48px;
`;
